module.exports = __webpack_public_path__ + "img/exchange-business-card.fa688fe0.svg";